define('shared/initializer/form/adapters/mixins/fields/CreditCardName',[
    'shared/lib/RSVP',
    '../../../constants'
], 
function(
    RSVP,
    constants
) {
    'use strict';

    var REGEX = /\S+\s+\S+/;

    function Ctor(){}

    Ctor.prototype.doPageLoad = function(){
        var me = this;
        var field = me.items[constants.FIELD.CREDIT_CARD_FULLNAME.toLowerCase()];

        if (field != null) {
            field.validate = function(value, options){
                if (!REGEX.test(value)) {
                    return RSVP.reject(
                        field.messages && (
                            field.messages['not-acceptable'] || 
                            field.messages.invalid
                        ) || 
                        (options && options.message) || 
                        'Must in the format of "Firstname Lastname"'
                    );
                }
                else {
                    return RSVP.resolve();
                }
            };   
        }

        return RSVP.resolve();
    };

    return Ctor;
});
